import { Controller } from "@hotwired/stimulus"

// Picking an encaissement selects its default payer, still editable. Only a change triggers it, so
// the step opens on the payer the contract actually has.
export default class extends Controller {
  static values = { defaults: Object }

  apply(event) {
    if (event.target.name !== "insurance_policy[billing_process]") return

    const payer = this.defaultsValue[event.target.value]
    const radio = payer && this.element.querySelector(`input[name="insurance_policy[payer_selector]"][value="${payer}"]`)
    if (radio) radio.checked = true
  }
}
